import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import EyeIcon from "@material-ui/icons/RemoveRedEye";
import PlusIcon from "@material-ui/icons/Add";
import LockIcon from "@material-ui/icons/Lock";
import TablePagination from "@material-ui/core/TablePagination";
import { Badge } from "react-bootstrap";
import { FaRegCreditCard } from 'react-icons/fa';
import StatusButton from "../../../_helpers/StatusButton";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Paper,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";

const headRows = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Ad",
  },
  {
    id: "surname",
    numeric: false,
    disablePadding: true,
    label: "Soyad",
  },
  {
    id: "middleName",
    numeric: false,
    disablePadding: true,
    label: "Ata adı",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email",
  },
  {
    id: "username",
    numeric: false,
    disablePadding: true,
    label: "İstifadəçi adı",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Vəziyyət",
  },
  {
    id: "tools",
    numeric: false,
    disablePadding: true,
    label: "Əməliyyatlar",
  },
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,

  } = props;

  return (
    <TableHead>
      <TableRow>

        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            sortDirection={orderBy === row.id ? false : false}
          >
            <TableSortLabel active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}>
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: "flex-end",
  },
  highlight:
    theme.palette.type === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },

  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  dense: {
    margin: theme.spacing(2),
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected, setShowCreate, permissionList } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >

      <div className={classes.actions}>
        {permissionList.some(element => element === "create_user") &&
          <Tooltip title="Əlavə et" placement="top">
            <button
              className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
              onClick={() => setShowCreate(true)}
            >
              <PlusIcon />
            </button>
          </Tooltip>}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#072C8C",
  },
}));

export default function EnhancedTable({
  groups,
  isLoading,
  setChooseGroupId,
  setOpenView,
  setShowCreate,
  setShowRemove,
  setShowRemoveGroups,
  setShowEdit,
  deleteGroupsIds,
  setDeleteGroupsIds,
  setShowChangePassword,
  setSortField,
  setOrderByTable,
  sortField,
  orderBy,
  updateSkip,
  updateTake,
  filterInputsUpdate,
  filterInputs,
  count,
  isError,
  setShowLog,

  onUpdateUserStatus

}) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const permissionList = useSelector(state => state.auth.permissionList)

  function handleRequestSort(property) {
    // const isDesc = sortField === property && !orderBy;
    const isDesc = sortField === property && orderBy === 'desc';


    // setOrderByTable(isDesc);
    setOrderByTable(isDesc ? 'asc' : 'desc');

    setSortField(property);
    updateTake(10);
    setRowsPerPage(10);
    updateSkip(0);
    setPage(0);
  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = groups.map((n) => n.id);
      setDeleteGroupsIds(newSelecteds);
      return;
    }
    setDeleteGroupsIds([]);
  }



  function handleChangePage(event, newPage) {
    setPage(newPage);
    updateSkip(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    updateTake(+event.target.value);
    setPage(0);
    updateSkip(0);
  }

  const isSelected = (id) => deleteGroupsIds.indexOf(id) !== -1;

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        <EnhancedTableToolbar
          numSelected={deleteGroupsIds.length}
          setShowCreate={setShowCreate}
          setShowRemoveGroups={setShowRemoveGroups}
          filterInputsUpdate={filterInputsUpdate}
          filterInputs={filterInputs}
          permissionList={permissionList}
        />

        <div className={classes.tableWrapper}>
          {groups.length ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={deleteGroupsIds.length}
                onSelectAllClick={handleSelectAllClick}
                rowCount={groups.length}
                order={orderBy}
                orderBy={sortField}
                onRequestSort={handleRequestSort}

              />
              <TableBody>
                {groups.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                    >

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.name ? row.name : "-"}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.surname ? row.surname : "-"}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.middleName ? row.middleName : "-"}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.email ? row.email : "-"}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {row.username ? row.username : "-"}
                      </TableCell>

                      <TableCell padding="default" className="pr-4 px-4">
                        <Badge
                          variant={
                            row.status === "INACTIVE"
                              ? "info"
                              : row.status === "ACTIVE" ? "success" : "-"
                          }
                        >
                          {row.status === "INACTIVE"
                            ? "Deaktiv"
                            : row.status === "ACTIVE" &&
                            "Aktiv"}
                        </Badge>
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                      >
                        {permissionList.some(element => element === "change_status_user") &&
                          <StatusButton
                            id={row.id}
                            status={row.status}
                            onUpdateUserStatus={onUpdateUserStatus}
                          />
                        }
                        <Tooltip title="Göstər" placement="top">
                          <button
                            aria-label="view"
                            className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                            onClick={() => {
                              setChooseGroupId(row.id);
                              setOpenView();
                            }}
                          >
                            <EyeIcon />
                          </button>
                        </Tooltip>
                        {permissionList.some(element => element === "edit_user") &&
                          <Tooltip title="Düzəliş et" placement="top">
                            <button
                              aria-label="edit"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-dark btn-hover-dark mr-2"
                              onClick={() => {
                                setChooseGroupId(row.id);
                                setShowEdit(true);
                              }}
                            >
                              <EditIcon />
                            </button>
                          </Tooltip>
                        }
                        {permissionList.some(element => element === "delete_user") &&
                          <Tooltip title="Sil" placement="top">
                            <button
                              aria-label="Delete"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger  mr-2"
                              onClick={() => {
                                setChooseGroupId(row.id);
                                setShowRemove(true);
                              }}
                            >
                              <DeleteIcon />
                            </button>
                          </Tooltip>}
                        {permissionList.some(element => element === "change_password_user") &&
                          <Tooltip title="Şifrəni dəyiş" placement="top">
                            <button
                              aria-label="changePassword"
                              className="btn btn-sm btn-icon btn-bg-light btn-text-warning btn-hover-warning mr-2"
                              onClick={() => {
                                setShowChangePassword(true);
                                setChooseGroupId(row.id);
                              }}
                            >
                              <LockIcon />
                            </button>
                          </Tooltip>}
                        {permissionList.some(element => element === "view_card_user") &&

                          <Tooltip title="Kart" placement="top">
                            <button
                              aria-label="Delete"
                              className={`btn btn-sm btn-icon btn-bg-light ${row.hasCard ? " btn-text-warning btn-hover-warning" : " btn-text-dark btn-hover-dark"}   mr-2`}
                              onClick={() => {
                                setChooseGroupId(row.id);
                                setShowLog(true);
                              }}

                            >
                              <FaRegCreditCard style={{ fontSize: "18px" }} />
                            </button>
                          </Tooltip>
                        }
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) :!groups.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}

        </div>
        {count > 10 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={count}
            labelRowsPerPage={"Sətirlərin sayı"}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Əvvəlki səhifə",
            }}
            nextIconButtonProps={{
              "aria-label": "Növbəti səhifə",
            }}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />)}
      </Paper>
    </div>
  );
}
